module.exports = __webpack_public_path__ + "static/media/illu_candidatures.9ddf02ae.svg";